import styled from "styled-components";
export const ContainerStyled = styled.div`:
display:  ${({ theme }) =>
    !["xm"].includes(theme.windowWidth) ? 'block' : 'flex'};;
 flex-direction: ${({ theme }) =>
    !["xm"].includes(theme.windowWidth) ? '' : 'column'};
  height: 100%;
  max-width: 650px;
  min-width: ${({ theme }) =>
    !["xm"].includes(theme.windowWidth) ? '600px' : '0'};
  margin: auto;
  display: flex;
  /* align-items: center; */
  justify-content: space-between;

  position: relative;

  & > div {
    flex-grow: 1;
    flex-basis: 48%;
    gap: 20px;
    margin: 0 10px;
    /* background-color: red; */
  }
`;
